<template>
  <v-card
    tile
    class="mr-4 d-inline-flex flex-column"
    :class="[isSelected && 'blue lighten-5 activeCard']"
    width="398"
    height="145"
    @click="onSelectEvent"
  >
    <div class="d-flex pt-3 pb-1 fill-height">
      <div class="px-4 pt-1">
        <div :class="[$style.statusIndicator, operationLevelColor]"></div>
      </div>
      <div class="d-flex flex-column">
        <div class="text-body-1">{{ event.title }}</div>
        <div class="text-body-2 d-flex align-items-center">
          <template v-if="event.reason">
            {{ event.reason.name }}
          </template>
          <template
            v-if="event.location || (event.routes && event.routes.length)"
          >
            <v-icon class="ml-1" small>mdi-map-marker</v-icon>
            {{ event.location }}
          </template>
          <template v-if="event.routes && event.routes.length">
            ({{ routes }})
          </template>
        </div>
        <div class="text-body-2 text--secondary" :class="$style.truncate">
          {{ event.comment }}
        </div>
        <div class="flex-grow-1 align-end d-flex">
          <span
            class="text-subtitle-2 font-weight-medium align-center pt-1 d-flex"
          >
            {{ event.time_start | dateTimeFormat }}
            <v-icon class="px-2" small>mdi-arrow-right</v-icon>
            -
          </span>
        </div>
      </div>
      <div>
        <EventMoreActionsButton :event="event" />
      </div>
    </div>
  </v-card>
</template>

<script>
import EventMoreActionsButton from './EventMoreActionsButton'
import operationLevelColor from '@/common/operationLevelColor'
import paramsDistrict from '@/common/paramsDistrict'
import { format } from 'date-fns'
import { sync } from 'vuex-pathify'

export default {
  name: 'EventCard',

  components: {
    EventMoreActionsButton
  },

  filters: {
    dateTimeFormat: v => format(new Date(v), 'yyyy-MM-dd HH:mm')
  },

  props: {
    event: Object
  },

  computed: {
    selectedUUID: sync('event/selectedUUID'),

    operationLevelColor() {
      const name = this.event.operation_level
        ? this.event.operation_level.name
        : ''
      return operationLevelColor(name)
    },

    isSelected() {
      return this.event.uuid === this.selectedUUID
    },

    routes() {
      return (this.event?.routes || [])
        .map(x => `${x.from_place}-${x.to_place}`)
        .join(', ')
    }
  },

  methods: {
    onSelectEvent() {
      if (this.isSelected) return
      this.$store.dispatch('event/selectEvent', this.event.uuid)
      window.history.replaceState(
        {},
        document.title,
        `/${paramsDistrict(this.$store.get('app/selectedDistrictId'))}/event/${
          this.event.uuid
        }`
      )
    }
  }
}
</script>

<style lang="scss">
.v-application .blue.lighten-5.activeCard {
  border: 1px solid blue !important;
}
</style>

<style lang="scss" module>
.truncate {
  width: 300px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: initial;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  display: -webkit-box;
}

.statusIndicator {
  width: 12px;
  height: 12px;
}
</style>
